<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <CCardHeader>
          <CRow>
            <CCol sm="7">
              <h4 id="traffic" class="card-title mb-0">Pendafataran - List</h4>
            </CCol>
            <CCol sm="5" class="d-none d-md-block"></CCol>
          </CRow>
        </CCardHeader>
        <CCardBody>
          <CRow>
            <CCol>
              <div><b>Category</b>: </div>
              <div>
                <CInputRadio
                    @input="choose($event)"
                    value="CORPORATION"
                    :inline="true"
                    name="category-business"
                    id="category-corporation"
                    label="Corporation" :checked="category.toUpperCase() === 'CORPORATION'"/>
                <CInputRadio
                    @input="choose($event)"
                    value="LILO"
                    :inline="true"
                    name="category-business"
                    id="category-lilo" label="Lilo" :checked="category.toUpperCase() === 'LILO'"/>
              </div>
            </CCol>
            <CCol sm="5" class="d-none d-md-block">
            <CRow class="float-right mb-2">
              <div class="search-list">
                <CCol sm="12">
                  <CInput
                    class="float-left mb-0 mr-2"
                    :placeholder="category.toUpperCase() === 'LILO' ? 'Search by Usaha/Merek' : 'Search By Nama Perusahaan'"
                    @input="search($event)"
                  >
                    <template #prepend-content>
                      <CIcon name="cil-magnifying-glass" />
                    </template>
                  </CInput>
                </CCol>
              </div>
            </CRow>
            </CCol>
          </CRow>
          <CDataTable
            hover
            striped
            :items="items"
            :fields="setFieldsLabel"
            :items-per-page="100"
            clickable-rows
            :active-page="activePage"
            :pagination="{ doubleArrows: false, align: 'center' }"
            @page-change="pageChange"
          >
            <template #job_position="data">
              <td>
                <div class="button-table">
                  <CButton
                    color="primary"
                    class="mb-0 mr-1"
                    @click="rowClicked(data.item.business_inquiry_id)"
                    >Follow Up</CButton
                  >
                </div>
              </td>
            </template>
          </CDataTable>
          <div class="pagination-nav">
            <div
              class="pagination-btn-refresh"
              @click="searchBusinessInquiry(lastSearch, 'REFRESH', category)"
            >
              Refresh
            </div>
            <div
              class="pagination-btn-back"
              @click="searchBusinessInquiry(lastSearch, 'BACK', category)"
            >
              back
            </div>
            <div class="pagination-page-title">{{ activePage }}</div>
            <div
              class="pagination-btn-next"
              @click="searchBusinessInquiry(lastSearch, 'NEXT', category)"
            >
              next
            </div>
          </div>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
// import usersData from './UsersData'
import axios from "axios";
import jwt from "jsonwebtoken";

export default {
  name: "BusinessInqueryRegistration",
  computed: {
    setFieldsLabel() {
      return this.category === "CORPORATION" ? this.fields : this.fieldsLilo;
    }
  },
  data() {
    return {
      items: [],
      fields: [
        { key: "business_inquiry_id", label: "ID" },
        { key: "company_name", label: "Nama Perusahaan" },
        { key: "pic_name", label: "Nama PIC" },
        { key: "phone_number", label: "Kontak PIC" },
        { key: "job_position", label: "Action" },
      ],
      fieldsLilo: [
        { key: "business_inquiry_id", label: "ID" },
        { key: "company_name", label: "Nama Usaha/Merek" },
        { key: "pic_name", label: "Nama Lengkap" },
        { key: "phone_number", label: "No. Handphone" },
        { key: "job_position", label: "Action" },
      ],
      activePage: 1,
      domain: process.env.VUE_APP_DOMAIN_URL,
      token: "Bearer " + localStorage.getItem("token"),
      category: "CORPORATION",
      lastSearch: "",
    };
  },
  mounted() {
    this.authentication();
  },
  created() {
    this.lastSearch = this.$route.query.search || ""
    this.category = this.$route.query.category || "CORPORATION"
    this.activePage = this.$route.query.page || 1
    this.searchBusinessInquiry(this.lastSearch, '', this.category.toUpperCase());
  },
  methods: {
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (
        data.account_group === "SALES" ||
        data.account_group === "ADMIN" ||
        data.account_group === "ADMINISTRATOR"
      ) {
        return null;
      } else {
        this.$router.push({ path: `/` });
      }
    },
    setHistory() {
      const q = '?page=' + this.activePage + '&category=' + this.category + '&search=' + this.lastSearch
      window.history.replaceState(null, null, q);
    },
    choose(e) {
      this.category = e.target.value
      this.searchBusinessInquiry(this.lastSearch, "", this.category)
    },
    getBadge(status) {
      switch (status) {
        case "NEW":
          return "success";
        case "FOLLOW UP":
          return "secondary";
      }
    },
    search(e) {
      this.lastSearch = e
      this.searchBusinessInquiry(e, '', this.category)
    },
    searchBusinessInquiry(event, action, cat = "CORPORATION", status = "NEW") {
      if (action === "NEXT") {
        this.activePage = this.activePage + 1;
      } else if (action === "BACK") {
        if (this.activePage > 1) {
          this.activePage = this.activePage - 1;
          window.scrollTo(0, 0);
        }
      } else if (action === "REFRESH") {
        this.activePage = 1;
        window.scrollTo(0, 0);
      } else {
        this.activePage = 1;
      }
      axios
        .get(
          `${this.domain}/v1/business/data?page=${this.activePage}&per_page=100&q=${event}&category=${cat}&status=${status}`,
          {
            headers: {
              Authorization: this.token,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          if (response.data.data.length > 0) {
            if (this.activePage > 1) {
              window.scrollTo(0, 0);
            }
            this.items = response.data.data;
            // const flag = "NEW";
            // this.items = response.data.data.filter(function(item) {
            //   return item.flag === flag;
            // });
          } else if (action === "NEXT") {
            this.activePage = this.activePage - 1;
          } else if (response.data.data.length === 0 && action === "") {
            this.items = response.data.data;
          }
          this.setHistory()
        })
        .catch((e) => {
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: e.response.data.message.id || "something went wrong",
          });
        });
      this.setHistory()
    },
    rowClicked(item) {
      this.$router.push({ path: `/business_inquiry/registration/${item}` });
    },
    pageChange(val) {
      this.$router.push({ query: { page: val } });
    },
    faqCreate() {
      this.$router.push({ path: `/business_inquiry/create` });
    },
  },
};
</script>

<style scoped>
@import "./BusinessInquiry.css";
</style>
